import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2, constants } from '@wsb/guac-widget-core';
import { debounce } from 'lodash';
import ReviewsAverageRating from '../ReviewsAverageRating';
import TopReviews from '../TopReviews';
import dataAids from '../constants/dataAids';

export const STATES = {
  ZERO: 'ZERO',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED',
  NO_REVIEWS: 'NO_REVIEWS'
};

const ENV_CONFIG = {
  local: 'dev-godaddy',
  development: 'dev-godaddy',
  test: 'test-godaddy',
  production: 'godaddy'
};

class ZillowReviews extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      state: STATES.ZERO,
      zillowData: {}
    };
    this.processZillowReviewsData = this.processZillowReviewsData.bind(this);
    this.refreshSearch = debounce(this.refreshSearch.bind(this), 350);
  }

  refreshSearch() {
    this.setState({ state: STATES.ZERO });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.screenNameAndEmail === this.props.screenNameAndEmail) {
      return;
    }
    this.refreshSearch();
  }

  displayMessage({ message }) {
    if (!message) return null;
    const styles = {
      container: {
        textAlign: 'center',
        paddingVertical: 'medium'
      }
    };
    return (
      <UX2.Element.Block style={ styles.container }>
        <UX2.Element.Text children={ message } data-aid={ dataAids.ZILLOW_MESSAGE_TEXT } />
      </UX2.Element.Block>
    );
  }

  fetchZillowReviewsData(cb) {
    const { id, pageId, websiteId, env, screenNameAndEmail, renderMode } = this.props;

    this.setState({ state: STATES.LOADING });

    let screenName, email;
    if (screenNameAndEmail.indexOf('@') === -1) {
      screenName = screenNameAndEmail;
    } else {
      email = screenNameAndEmail;
    }

    // eslint-disable-next-line max-len
    let url = `https://proxy.apps-api.instantpage.${ENV_CONFIG[env]}.com/v1/proxy/zillowReviews?widgetId=${id}&pageId=${pageId}&websiteId=${websiteId}`;
    if (renderMode !== constants.renderModes.PUBLISH) {
      url = `https://proxy.apps-api.instantpage.${ENV_CONFIG[env]}.com/v1/proxy/zillowReviews?`;
      if (screenName) url += `screenname=${screenName}`;
      if (screenName && email) url += '&';
      if (email) url += `email=${email}`;
    }

    if (typeof XMLHttpRequest !== 'undefined') {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          return void cb(JSON.parse(xhr.responseText));
        }
        return void this.setState({ state: STATES.FAILED });
      };
      xhr.open('GET', url, true);
      xhr.send();
    }
  }

  processZillowReviewsData(data) {
    const zillowData = data;
    if (zillowData.reviews.length === 0) {
      return void this.setState({ state: STATES.NO_REVIEWS });
    }
    zillowData.avgRating = parseFloat(zillowData.avgRating);
    zillowData.reviews = zillowData.reviews.map(review => {
      review.rating = parseFloat(review.rating);
      return review;
    });
    this.setState({ zillowData, state: STATES.LOADED });
  }

  performActionsAndFetchData() {
    const { staticContent, renderMode } = this.props;
    const { state, zillowData } = this.state;
    // define the schema of the data
    const data = {
      message: '',
      zillowData: {}
    };
    if (state === STATES.ZERO) {
      this.fetchZillowReviewsData(this.processZillowReviewsData);
    } else if (state === STATES.LOADING) {
      data.message = staticContent.loadingStateMessage;
    } else if (state === STATES.LOADED) {
      data.zillowData = zillowData;
    } else if (state === STATES.FAILED) {
      data.message = staticContent.failedStateMessage;
    } else if (state === STATES.NO_REVIEWS) {
      if (renderMode === constants.renderModes.EDIT) {
        data.message = staticContent.noReviewsStateMessage;
      } else {
        data.message = staticContent.failedStateMessage;
      }
    } else {
      // this shouldn't be reached
      // eslint-disable-next-line no-console
      console.warn(`State: ${state} is unsupported`);
    }

    return data;
  }

  render() {
    const data = this.performActionsAndFetchData();
    const { staticContent } = this.props;
    const { state } = this.state;
    return (
      <React.Fragment>
        <ReviewsAverageRating
          zillowData={ data.zillowData }
          staticContent={ staticContent }
          state={ state }
        />
        { this.displayMessage(data) }
        <TopReviews zillowData={ data.zillowData } staticContent={ staticContent } state={ state } />
      </React.Fragment>
    );
  }
}

ZillowReviews.propTypes = {
  id: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
  websiteId: PropTypes.string.isRequired,
  renderMode: PropTypes.string.isRequired,
  env: PropTypes.string.isRequired,
  staticContent: PropTypes.object.isRequired,
  screenNameAndEmail: PropTypes.string
};

export default ZillowReviews;
